module.exports = __webpack_public_path__ + "static/img/行业特性应用5.0ffb3c1d.png";